import { useEffect, useRef } from 'react';
import { useAnalytics } from '~/context/analytics';

/**
 * Records that this page load arrived from the activity-notification email.
 *
 * Settings still lives on the client app. The email tags that landing with
 * `utm_medium=notification_email` so this can fire the same event town-square
 * records for `/notifications` and profile links.
 */
export function NotificationEmailAttribution() {
  const { amplitude } = useAnalytics();
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;

    const params = new URLSearchParams(window.location.search);
    // Kept identical to the town-square copy named in the comment above — the digest's
    // settings and hide-community links land here, and they carry `utm_source=digest` with
    // `utm_medium=email` rather than `notification_email`.
    const isNotificationEmail = params.get('utm_medium') === 'notification_email';
    const isDigest = params.get('utm_source') === 'digest';
    if (!isNotificationEmail && !isDigest) return;

    amplitude.track('notification_email_link_clicked', {
      link: params.get('utm_content') ?? 'unknown',
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_term: params.get('utm_term'),
      // WHICH SUBJECT earned this landing, not just which link was pressed.
      // The email's subject rotates across framings — a comment named by its
      // author, a count, "somebody is still waiting on you" — and without this
      // the click numbers can only say that the email works, never which
      // framing made it work. Stamped on every link by `tagEmailUrl`;
      // `utm_campaign` because `utm_content` IS the which-link dimension above
      // and `utm_term` is tested for exact equality by two other landings.
      variant: params.get('utm_campaign'),
      path: window.location.pathname,
    });
  }, [amplitude]);

  return null;
}
